import React from 'react';
import { ArrowRight } from 'lucide-react';

export const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      paddingTop: '120px',
      paddingBottom: 'var(--spacing-giant)',
      position: 'relative'
    }}>
      <div className="container">
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
          gap: 'var(--spacing-xl)',
          alignItems: 'center'
        }}>
          {/* Text Content */}
          <div>
            <h1 className="display-large" style={{ marginBottom: 'var(--spacing-medium)' }}>
              Rückenschmerzen, schlechte Haltung oder ständige Müdigkeit?
            </h1>
            <p className="body-large" style={{ marginBottom: 'var(--spacing-large)' }}>
              Hol dir deine Bewegungsfreiheit und Körperkontrolle in nur 12 Wochen mit dem Haltung-Reset-System zurück.
            </p>
            <p className="body-medium" style={{ marginBottom: 'var(--spacing-xl)', color: 'var(--text-secondary)' }}>
              Ohne Fitnessstudio, ohne Überlastung – nur durch bewusste Bewegung, funktionelles Training und Physiologie.
            </p>
            <button className="btn-cta" onClick={() => scrollToSection('tarife')}>
              Jetzt starten – Haltung-Reset buchen <ArrowRight size={20} style={{ display: 'inline', marginLeft: '8px', verticalAlign: 'middle' }} />
            </button>
          </div>

          {/* Hero Image */}
          <div style={{
            borderRadius: '32px',
            overflow: 'hidden',
            boxShadow: '0 8px 32px rgba(0, 69, 52, 0.2)',
            minHeight: '500px'
          }}>
            <img 
              src="https://customer-assets.emergentagent.com/job_haltung-reset/artifacts/opnozxeb_IMG_0898.jpeg"
              alt="Outdoor Gruppentraining"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                display: 'block'
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};